(() => {
  if (window.shopdeMobileProductHeader) {
    window.shopdeMobileProductHeader.refresh();
    return;
  }

  const mobile = window.matchMedia('(max-width: 989px)');
  const getShopDestination = (value, allowQueryChange = false) => {
    if (!value) return null;
    try {
      const destination = new URL(value, window.location.origin);
      if (
        destination.origin !== window.location.origin ||
        destination.username ||
        destination.password ||
        (destination.pathname === window.location.pathname &&
          (!allowQueryChange || destination.search === window.location.search))
      ) return null;
      return destination;
    } catch {
      return null;
    }
  };

  const getPreviousEntry = () => {
    try {
      const navigation = window.navigation;
      if (!navigation?.currentEntry || typeof navigation.entries !== 'function') return null;
      const entries = navigation.entries();
      const index = entries.findIndex((entry) => entry.key === navigation.currentEntry.key);
      return index > 0 ? getShopDestination(entries[index - 1].url, true) : null;
    } catch {
      return null;
    }
  };

  const getDestination = (link) => {
    const previousEntry = getPreviousEntry();
    return {
      url: previousEntry || getShopDestination(document.referrer) || new URL(link.dataset.shopdeBackFallback || link.getAttribute('href'), window.location.origin),
      useHistory: Boolean(previousEntry)
    };
  };

  const refresh = () => {
    document.querySelectorAll('[data-shopde-product-back]').forEach((link) => {
      if (!link.dataset.shopdeBackFallback) link.dataset.shopdeBackFallback = link.getAttribute('href');
      link.href = getDestination(link).url.href;
    });
  };

  window.shopdeMobileProductHeader = { refresh };
  refresh();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-shopde-product-back]');
    if (!link || !mobile.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = getDestination(link);
    link.href = destination.url.href;
    if (destination.useHistory) {
      event.preventDefault();
      window.history.back();
    }
  });
})();
